import {connect} from "react-redux";
import Meta from "../../_data/models/Meta";
import Shop from "../../_data/models/Shop";
import {plainToClass} from "class-transformer";
import {ShopProfessionalsComponent} from "../components/ShopProfessionalsComponent";
import User from "../../_data/models/User";
import {usersSelector} from "../../_data/selectors";
import {shopProfileProfessionalSelector} from "../selectors";
import {fetchShopProfessionals} from "../middlewares";


const mapDispatchToProps = (dispatch, props) => {

    return {
        loadMore: (meta: Meta) => {
            if (meta && meta.hasNext()) {
                dispatch(fetchShopProfessionals(props.shop.id, meta.cursor, meta.nextPage));
            }
        }
    };
};

const mapStateToProps = (state, props) => {

    const items = usersSelector(state).filter((each) => {
        return shopProfileProfessionalSelector(state).ids.has(each.id) && each instanceof User;
    }).toArray();

    return {
        items: items,
        meta: shopProfileProfessionalSelector(state).meta,
        loading: shopProfileProfessionalSelector(state).loading
    };
};

const ShopProfessionalsContainer = connect(mapStateToProps, mapDispatchToProps)(ShopProfessionalsComponent);
export default ShopProfessionalsContainer;


// WEBPACK FOOTER //
// ./app/client/shop/container/ShopProfessionalsContainer.ts